<template>
	<div id="ae-book-tracker" class="view-content">
		<div class="page-heading">
			<h1>AE Book Tracker</h1>
			<breadcrumb :items="breadcrumb_items" />
		</div>
		<AEBookTrackerTable />
	</div>
</template>

<script>
import AEBookTrackerTable from './Table.vue';

export default {
	name: 'AEBookTracker',
	components: {
		AEBookTrackerTable,
	},
	data() {
		return {
			breadcrumb_items: [
				{
					label: 'SAUT',
				},
				{
					label: 'AE Book Tracker',
				},
			],
		};
	},
};
</script>
